import { Icon } from 'react-feather'

type IconContainerProps = {
  icon: Icon
  bgColor: string
  textColor: string
}

export const IconContainer = ({
  icon: IconComponent,
  bgColor,
  textColor,
}: IconContainerProps) => {
  return (
    <div
      className={`w-8 h-8 ${bgColor} p-[6px] rounded-lg flex items-center justify-center`}
    >
      <IconComponent size={18} className={textColor} />
    </div>
  )
}
